'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = selection;

var _immutable = require('immutable');

var Immutable = _interopRequireWildcard(_immutable);

var _lodash = require('lodash');

var _selectionConstants = require('../../../common/elements/selectionConstants');

var SELECTION_ACTION_TYPES = _interopRequireWildcard(_selectionConstants);

var _undoRedoConstants = require('../../utils/undoRedo/undoRedoConstants');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Constants
// Lib
var initialState = Immutable.fromJS({
    ids: [],
    keepSelection: false
});

function selection() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case SELECTION_ACTION_TYPES.ELEMENTS_SELECTED:
            return state.update('ids', function (ids) {
                return ids.concat(action.ids);
            });
        case SELECTION_ACTION_TYPES.ELEMENTS_DESELECTED:
            return state.update('ids', function (ids) {
                return ids.filterNot(function (id) {
                    return (0, _lodash.includes)(action.ids, id);
                });
            });
        case SELECTION_ACTION_TYPES.ELEMENTS_DESELECT_ALL:
        case '@@router/LOCATION_CHANGE':
            return state.get('keepSelection') ? state : initialState;
        case _undoRedoConstants.START_OPERATION:
            return state.set('keepSelection', true);
        case _undoRedoConstants.END_OPERATION:
            return state.set('keepSelection', false);
        default:
            return state;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/client/element/selection/selectionReducer.js
// module id = 2025
// module chunks = 0